<template>
  <div class="questionnaires">
    <div class="inner-content">
      <Alert></Alert>

      <div class="questionnaires-list" v-if="questionnaires.length > 0">
        <v-row>
          <Card
            v-for="questionnaire in questionnaires"
            :key="`questionnaire-${questionnaire.ID}`"
            :title="questionnaire.post_title"
            :link="{ name: 'questionnaire', params: {id: questionnaire.ID} }"
            dark
          ></Card>
        </v-row>
      </div>

      <h3 v-if="questionnaires.length === 0 && !loading">Не бяха намерени актуални анкети.</h3>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/helpers'
import { mapGetters } from 'vuex'
import Card from '@/components/Card'
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'QuestionnaireList',
  components: { Alert, Card },

  mounted () {
    this.fetchQuestionnaires()
  },

  methods: {
    formatDate,
    fetchQuestionnaires () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getQuestionnaires').then(() => {
        this.$store.commit('setLoading', false)
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на анкетите.' })
      })
    }
  },

  computed: mapGetters(['questionnaires', 'loading']),
}
</script>
